
/* - */
export const pdfFiles = [
    {
        name: "Dans les coulisses du LFI Tokyo",
        url: "https://www.clublfit.org/Journal/Bonsai_hiver2022.pdf",
        image: "/images/Bonsai_hiver2022.png",
        date: "2023-02-01",
        keywords: ["Godimus", "Dehez", "cuisine", "Bordeaux", "roman"],
        articles:
            [
            "Le sapin de Noël de Bordeaux,une affaire épineuse",
            "Interview de M. Godimus",
            "“La vie invisible d’Addie Larue” de V.E.Schwab : un roman revisitant le mythe de Faust",
            "Interview de maman",
            "Dans l’arrière cuisine du LFI Tokyo",
            "JEUX",
            ],
        rédacteurs: ["LECLERCQ Emilie","LUNA ROSSIGNEUX","IRIS TRONQUET","Nathalie DUHOMEZ","Lilia","Manon Vu Huu","Solene","Aya DIABAT","Misaki TORNATO"],
        illustration : ["BROUQUEYRE Ema", "Naomi HURE", "Misaki TORNATO"],
        maquetistes: ["", ""],
        summary: "Édition spéciale Février 2023.",
        number: 1,
        type: "actualités",
        language: ["fr"]
    },
    {
        name: "Les “Tiktoks Artists”",
        url: "https://www.clublfit.org/Journal/Bonsai_hiverDec2022.pdf",
        image: "/images/Bonsai_hiverDec2022.png",
        date: "2022-11-01",
        keywords: ["fourmis", "nucléaire", "plastiques", "original","écologie","TikTok","rap","photographie","Foot","Chine"],
        articles:
        [
        "Des fourmis kamikazes découvertes récemment",
        "Poutine : un risque nucléaire ?",
        "Des plastiques aux microplastiques",
        "Êtes-vous original ? ",
        "En 2013",
        "5 idées reçues sur l'écologie",
        "Les “TikTok Artists”",
        "Agent orange",
        "10 meilleurs albums de rap pas tous connus",
        "La photographie en noir et blanc, une approche à explorer",
        "LFITokyo vs St Marys",
        "Xi Jinping, président chinois à vie ?",
        "JEUX",
        ],
        rédacteurs: ["Mattias Thomas", "Anonyme","Aya Diabat","Loïc Vu Huu","Manon Vu Huu","Margot Sancy","Gaspard Langlois","Yaël Sitbon","Abigaïl Aimé","Luke Sagnard","Alexandre Flament"],
        maquetistes: ["Luna Rossigneux", "Émilie Stettler","Daphné Tronquet","Suzuné Aochi"],
        summary: "Édition spéciale Décembre 2022",
        number: 2,
        type: "actualités",
        language: ["fr"]
    },
    // Ajoutez les autres éditions ici...
];
